import { createReducer, on } from '@ngrx/store';

import { goToProjects, setProject } from '../../core/store';
import {
	fetchTraceListPerPageFail,
	fetchTraceListPerPageSuccess,
	getTraceListPerPage,
} from './trace.actions';
import { TraceOriginalSliceState } from './trace.state';

export const traceOriginalReducer = createReducer<TraceOriginalSliceState>(
	new TraceOriginalSliceState(),
	on(goToProjects, setProject, (state) => state.clear()),
	on(getTraceListPerPage, (state) => state.setLoading(true)),
	on(fetchTraceListPerPageSuccess, (state, action) =>
		state
			.setLoading(false)
			.setTraceList(action.traceList)
			.setTotal(action.total)
	),
	on(fetchTraceListPerPageFail, (state) => state.setLoading(false))
);
